<template>
    <ul class="list-none p-3 m-0" dir="rtl">
        <ul class="list-none p-0 m-0 overflow-hidden">
            <li v-for="(e, index) in filteredMenuEntries" :key="index" @click="navigate(e.to)">
                <a v-ripple
                    class="flex align-items-center cursor-pointer p-3 border-round text-color hover:text-white hover:surface-hover transition-duration-150 transition-colors p-ripple">
                    <i :class="[e.ficon, shouldBounce(e) ? 'animation-duration-1000 animation-iteration-infinite fadeout' : '']" style="font-size: 1.25rem"></i>
                    <span style="cursor: pointer;" class="font-medium mr-3 ml-auto">{{ $t(e.label) }}</span>
                    <span v-if="showCounter(e)"
                          class="inline-flex align-items-center justify-content-center .mr-auto surface-50 border-circle font-medium text-primary hover:text-white"
                          style="min-width: 1.5rem; height: 1.5rem">{{ counter(e) }}</span>
                </a>
                <Divider v-if="index === 0 || index === 4" />
            </li>
        </ul>
    </ul>
</template>

<script setup>
import { ref, onMounted, watch, computed } from "vue"
import { useAuthStore } from '@/stores/auth'
import { useI18n } from 'vue-i18n'
import { useRoute } from 'vue-router'
import router from '@/router/router'
import menuHelper from "@/helpers/MenuHelper"
import Divider from 'primevue/divider'

const authStore = useAuthStore()
const i18n = useI18n()
const route = useRoute()
const visible = ref(false)
const menuEntries = ref([])
const currentView = ref()

watch(route, () => {
    if (route.name !== '' && route.name !== 'login') {
        currentView.value = i18n.t(getTitlesMap()[route.name])
    }
})

onMounted(() => {
    menuHelper.makeSideMenu(authStore.amIAdmin()).forEach(e => menuEntries.value.push(e))
})

const getTitlesMap = () => {
    return {
        'home': 'HOME',
        'controlPanel': 'HOME',
        'profile': 'PROFILE_MENU',
        'gift_request': 'GIFT',
        'borrowing_request': 'BORROW',
        'exchange_request': 'EXCHANGE',
        'operations': 'OPERATIONS',
        'messages': 'MESSAGES_MENU',
        'my_books': 'MY_BOOKS',
        'notifications': 'NOTIFICATIONS',
        'covers': 'COVER_CORRECTION',
        'user_join_requests': 'USER_JOIN_REQUESTS',
        'upload_books': 'UPLOAD_BOOKS',
        'import_books': 'UPLOAD_BOOKS',
        'books': 'BOOKS',
        'rewards': 'REWARDS'
    }
}

const filteredMenuEntries = computed(() => {
    return menuEntries.value.filter((_, index) => index !== 9)
})

const navigate = (url) => {
    if (url !== null && url !== undefined) {
        visible.value = false
        setTimeout(() => {
            router.push(url)
        }, 500)
    }
}

const counter = (item) => {
    return authStore[item.bounceVar] > 0 ? authStore[item.bounceVar] : 0;
}

const showCounter = (item) => {
    return counter(item) > 0;
};

const shouldBounce = (item) => {
    return counter(item) > 0;
}
</script>



<style scoped>
img#profile_image {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    box-shadow: 0 0 10px rgb(0 0 0 / 16%);
}

.side_bar_top {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: 2em;
    padding-bottom: 0.5em;
}

.menu-entry {
    margin-bottom: 10px;
}

.menu-entry-icon {
    display: inline-block;
    width: 35px;
    text-align: center;
}

.counter-container {
    display: inline-block;
    width: 10px;
}

.counter {
    color: red;
    vertical-align: super;
    margin-right: -3px;
}
</style>
